export enum HarcMasrafTypeEnum {
    HARC_MASRAF = "H",
    TAHSILAT = "T",
    PUL = "D"
}